export const sortableUid = () => {
	const date = new Date().toISOString().split('T').shift().split('-').join('').substring(2)
	const randomString = Math.round(Date.now() * Math.random()).toString();
		// .toString(30)
		// .substring(0, 2)
		// .toUpperCase()
	return `${date}-${randomString}`
}